
import { Button } from '@/components/ui/button';
import {
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { RefreshCcw, UserPlus } from 'lucide-react';

interface UserManagementHeaderProps {
  onRefresh: () => void;
  onAddUser: () => void;
}

export default function UserManagementHeader({
  onRefresh,
  onAddUser,
}: UserManagementHeaderProps) {
  return (
    <CardHeader className="flex flex-row items-center justify-between">
      <div>
        <CardTitle>Gestion des Utilisateurs</CardTitle>
        <CardDescription>
          Gérez les utilisateurs, leurs rôles et leurs accès
        </CardDescription>
      </div>
      <div className="flex space-x-2">
        <Button 
          variant="outline" 
          size="icon"
          onClick={onRefresh}
          title="Rafraîchir la liste"
        >
          <RefreshCcw className="h-4 w-4" />
        </Button>
        <Button onClick={onAddUser} className="flex items-center">
          <UserPlus className="h-4 w-4 mr-2" />
          Ajouter un utilisateur
        </Button>
      </div>
    </CardHeader>
  );
}
